module.exports = __webpack_public_path__ + "static/scale-model-of-nebraska-tourism-commision-in-lincoln-nebraska-401f933baa658ec816d2cf28b40392c3.png";